import React, { Component } from "react";
import { Container } from "reactstrap";
import "./footer.css";

class componentName extends Component {
  render() {
    return (
      <div>
        <Container>
          <h1>Frequently Asked Questions</h1>
        </Container>

        <Container style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <br />
          <br />
          <p>
            <b>Tell me more about Lighthouse</b>
            <br />
            <br />
            Lighthouse is a skill accelerated talent marketplace. To put it
            simply, we are a tech talent marketplace and an education
            institution combined into one entity. Why? Drawing from our decades
            of experience in the technology industry, we believe that helping
            everyone build data, coding, design, software development and cloud
            skills, which are in demand, is the key to build a workforce which
            can reverse the offshoring tide. We think that we can provide a
            great answer to build a local and inclusive tech-workforce.
            <br />
            <br />
            By training digital-ready tech talent, our larger mission to help
            build an economically inclusive workforce can be reached. After all,
            cities thrive on job creation, especially tech job creation.
            <br />
            <br />
            Our decades of experience in building digital-ready talent and our
            industry advisors have helped us design our curriculum. Our
            curriculum answers the most pressing industry need to find talent
            that's ready to build software applications which are –
            experiential, e-commerce ready, intelligent and globally scalable.
            <br />
            <br />
            Our experiential learning facility is located in 3 Alliance Center,
            Buckhead -- a thriving neighborhood of Fortune 500s to Start-ups,
            all in walking distance. We are working to open up centers in other
            cities and working with our enterprise customers to scale their
            talent as well. We offer world-class, affordable training in
            full-stack coding, data sciences, cybersecurity and related digital
            technologies for the jobs of today and tomorrow.
            <br />
            <br />
            <br />
            <b>
              I have friends who have done other bootcamps but they seem to
              struggle – what makes you different so that I succeed in my job?
            </b>
            <br />
            <br />
            That is a good question. Coming from decades in the technology
            services industry where we trained thousands of people to become
            software engineers, we are clued into the productivity demands of
            companies. That’s why we designed our curriculum in a way so that
            you can understand complete software development. To reiterate: it
            is about building experiential, e-commerce ready, intelligent and
            globally scalable applications. We studied over one hundred and
            fifty bootcamp programs and various training programs provided in
            some of the largest tech services companies to design our top-rated
            curriculum.
            <br />
            We believe the devil lies in the details and we will encourage you
            to talk to one of our students or attend one of our information
            sessions. Our methodology, our rigor, our focus on making you
            prepared for the job is what makes us different. Our mission is that
            once you are accepted at Lighthouse, we will become your career
            partners forever.
            <br />
            <br />
            <br />
            <b>
              Some programs talk about their transparency, honesty, class sizes,
              instructors – Do you have all of that at Lighthouse?
            </b>
            <br />
            <br />
            The answer is yes. But before we answer that in detail, let us ask
            you – would you go to any institution which does not offer
            transparency, honesty, good instruction, etc.? Or for that matter,
            even work for a company that lacks those values? We know, your
            answer is a big NO. So, this is all table stakes. Lighthouse can
            give all of that and more – an institution who is interested in your
            lifelong career rather than just one program you’ve enrolled into,
            being present with you more like BFFs would be. Whether it's
            assigning you mentors, or getting you through coding challenges, or
            even simulating the live work environment in our digital-studio
            style classrooms, we will always be with you. We'll be ready with
            more skill building opportunities as you progress in your career or
            as technology changes. Don’t forget to ask us about our motto, “Stay
            relevant, forever.” We want you to hear it from us personally, so we
            won’t write about it here. Come chat with us!
            <br />
            <br />
            <br />
            <b>
              OK, job interview prep is one thing and career guidance is
              another, how will rely on you to provide us with the proper
              guidance.
            </b>
            <br />
            <br />
            Yes, a generic interview prep or just asking students to endlessly
            post on social media to keep you busy during the day will not get
            you a job. Orientation for the right kind of work begins with asking
            yourself a question: what kind of software engineer or data
            scientist do I want to become? Do I want to be working on cutting
            edge stuff and spending long hours with innovation teams or do I
            want to be renovating the applications because there is so much to
            be fixed in companies and so many new ways to help customers? These
            proper questions create a highly curated approach to what should be
            in your resume and what type of projects you need to focus on. Well,
            we will stop here but you get it. Our approach is based on our
            lifelong software industry experience. So we know what you need to
            reach your career goals.
            <br />
            <br />
            <br />
            <b>Do you offer job guarantees?</b>
            <br />
            <br />
            We do not and no one can without multiple strings attached. Getting
            you a job is a three party function – 1) our training, 2) employers'
            time of need, and of course 3) your competitive demonstration of
            desired skills to the prospective employer (remember the time when
            ‘Avatar’ did not win the Academy Award but ‘Hurt Locker' did and
            both were amazing movies).
            <br />
            Our goal is to bring the above three parties to converge at the same
            point in the most effective way. We are building a talent
            marketplace and we are interested in getting you a job not only the
            first time but every time. So, from our side, rest assured we won’t
            leave any stone unturned -- be it training, interview prep, project
            work, soft skills or interaction with our featured employers. You
            will have it all and much more.
            <br />
            <br />
            <br />
            <b>ISAs (Income Share Agreements), do you offer any?</b>
            <br />
            <br />
            Our goal is to provide affordable education and in a way that
            students don’t get into more debt. Income Share Agreements, allow
            our course participants to forgo the tuition until they are employed
            and earning a gross income of $40k or more on an annualized basis.
            Once earning at or above that threshold, your payments begin.
            Payments then continue for 60 months, as long as you're earning at
            least $40,000 per year, at a rate of 10% of your monthly income. The
            payments will continue for 60 months, and may never exceed $24,000
            in total. ISAs are limited to Software Engineering Immersive
            students only, and are only available to the maximum of 5
            participants in any given cohort. All students still need to submit
            a $1,500 deposit to secure their seat in class, which is fully
            refundable should you withdraw before class starts. Please talk to
            your local administrator or drop us a note at
            info@itslighthouse.comfor more details.
            <br />
            <br />
            <br />
            <b>Tell me more about your discounts and scholarships?</b>
            <br />
            <br />
            We encourage you to go to our courses page or refer to out catalogue
            for the latest information on tuition, scholarships, discounts,
            credits and payment methods.
            <br />
            <br />
            <b>How can I enroll into a course of my choice?</b>
            <br />
            <br />
            We may employ third party companies and individuals to facilitate
            our Service, to provide the Service on our behalf, to perform
            Service-related services and/or to assist us in analyzing how our
            Service is used.
            <br />
            <br />
            <br />
            <b>Is my deposit refundable?</b>
            <br />
            <br />
            Yes, your $1,500 deposit is fully refundable should you withdraw
            before class starts. Of course, we don’t want to keep your money if
            you are not interested or have a change of heart.
            <br />
            <br />
            <br />
            <b>What's included in my tuition?</b>
            <br />
            <br />
            <ul>
              <li>
                Expert-led training in software development skills, methods, and
                best practices.
              </li>
              <li>Access to an assigned mentor.</li>
              <li>
                Additional online courses, workshops, participation at select
                Lighthouse sponsored events.
              </li>
              <li>
                Additional Stay Relevant, Forever perks, discounts, workshop
                credits, and more.
              </li>
              <li>
                Ongoing job search support and exclusive networking
                opportunities.
              </li>
              <li>
                Support in preparing for technical interviews and coding
                challenges.
              </li>
              <li>
                Access to a dedicated group of career advisors to help you land
                a job after graduation.
              </li>
            </ul>
            <br />
            <br />
            <br />
            <b>What can I expect to accomplish as I near my graduation?</b>
            <br />
            <br />
            By the time you graduate you will have:
            <br />
            <ul>
              <li>
                Portfolio Projects: While project portfolio differs course by
                course, every course requires you to focus on building portfolio
                projects.
              </li>
              <li>
                Practiced multiple times for coding challenges and technical
                interviews.
              </li>
              <li>
                Built a rapport with a mentor to guide you through your emerging
                tech career.
              </li>
              <li>
                Developed a lifelong community which includes – you, Lighthouse,
                our alums, your instructors, classmates, mentors and visiting
                industry experts.
              </li>
            </ul>
         
          </p>
        </Container>
      </div>
    );
  }
}

export default componentName;
